import {
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { getAllCategories } from '../../models/Categories Requests DTO/get-categroies.model';
import { CategoryService } from '../../Services/category.service';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-category-card',
  templateUrl: './category-card.component.html',
  styleUrl: './category-card.component.scss',
})
export class CategoryCardComponent implements OnInit {
  categoryId = input.required<number>();
  category!: getAllCategories;
  categoryname!: string;

  CategoryService = inject(CategoryService);
  languageService = inject(LanguageService);
  language = this.languageService.getLanguage();

  ngOnInit(): void {
    this.CategoryService.getSingleCategory(this.categoryId()).subscribe({
      next: (resopnse) => {
        this.category = resopnse;
        this.loadData();
      },
      error: (err) => {
    //    console.log(err);
      },
    });
  }

  loadData() {
    this.languageService.currentLanguage$.subscribe((language) => {
      switch (language) {
        case 'En':
          this.categoryname = this.category.nameEn;
          break;
        case 'Tr':
          this.categoryname = this.category.nameTr;
          break;
        case 'Ar':
          this.categoryname = this.category.nameAr;
          break;
        default:
          this.categoryname = this.category.nameEn; // Fallback
      }
    });
  }

  //for animation purposes
  @ViewChildren('container') containers!: QueryList<ElementRef>; // Query all containers
  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active'); // Add the 'active' class
            entry.target.classList.remove('inactive'); // Remove the 'inactive' class
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      { threshold: 0.8 } // Trigger when 20% of the element is visible
    );

    // Observe each container
    this.containers.forEach((container) => {
      observer.observe(container.nativeElement);
    });
  }
}
